import { CustomerAccess } from 'models/customer_access_history';

export function addCustomerToAccessHistory(context, customerId) {
  let customerAccessHistory = context.stores.customerAccessHistory.get();
  customerAccessHistory.put(CustomerAccess.create({ id: customerId }));
  context.stores.customerAccessHistory.set(customerAccessHistory);
}

export function removeCustomerFromAccessHistory(context, customerId) {
  let customerAccessHistory = context.stores.customerAccessHistory.get();
  customerAccessHistory.remove(customerId);
  context.stores.customerAccessHistory.set(customerAccessHistory);
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/lib/customer_access_history.js